import SEOHead from '@/components/base/SEOHead';
import ScrollToTop from '@/components/base/ScrollToTop';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import TrendingSection from './components/TrendingSection';
import LatestSection from './components/LatestSection';
import FeaturesSection from './components/FeaturesSection';
import ExploreSection from './components/ExploreSection';

export default function Home() {
  const pageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '91视频网站 - 高清视频在线观看平台',
    description: '91视频网站是您发现和观看高清视频的首选平台，海量视频资源免费在线播放，涵盖影视、综艺、短视频等多种类型',
    url: 'https://91video.example.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '91视频网站',
      url: 'https://91video.example.com',
    },
  };

  return (
    <>
      <SEOHead
        title="91视频网站 - 高清视频在线观看平台 | 海量影视综艺短视频免费播放"
        description="91视频网站是您发现和观看高清视频的首选平台，海量视频资源免费在线播放，涵盖影视、综艺、短视频等多种类型，流畅播放体验，立即访问91视频网站，开启精彩视频世界。"
        keywords="91视频网站,91视频网站在线观看,91视频网站高清播放,91视频网站免费资源,91视频网站最新内容,视频在线播放平台,高清视频网站推荐"
        canonicalUrl="https://91video.example.com/"
        schema={pageSchema}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <TrendingSection />
        <LatestSection />
        <FeaturesSection />
        <ExploreSection />
      </main>
      <Footer />
    </>
  );
}